// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ReactDatepicker = require("./ReactDatepicker").default;
var JsxRuntime = require("react/jsx-runtime");

var make = ReactDatepicker;

var JS = {
  make: make
};

function ReactDatepicker$1(props) {
  var onChange = props.onChange;
  var __placeholderText = props.placeholderText;
  var placeholderText = __placeholderText !== undefined ? __placeholderText : "Select date...";
  return JsxRuntime.jsx(make, {
              selected: Core__Option.map(props.selected, CalendarDate.toLocalDate),
              onChange: (function (v) {
                  var v$1 = (v == null) ? undefined : Caml_option.some(v);
                  if (onChange !== undefined) {
                    return onChange(Core__Option.map(v$1, CalendarDate.fromLocalDate));
                  }
                  
                }),
              placeholderText: placeholderText,
              minDate: Core__Option.map(props.minDate, CalendarDate.toLocalDate),
              maxDate: Core__Option.map(props.maxDate, CalendarDate.toLocalDate),
              status: props.status,
              disabled: props.disabled
            });
}

var make$1 = ReactDatepicker$1;

exports.JS = JS;
exports.make = make$1;
/* make Not a pure module */
